function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.9998,
  cy: 5.40776,
  r: 1.2,
  fill: "#A4A5A8"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.9998,
  cy: 18.5137,
  r: 1.2,
  fill: "#A4A5A8"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.9998,
  cy: 2.47417,
  r: 1.2,
  fill: "#A4A5A8"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.79961,
  cy: 7.2,
  r: 1.2,
  fill: "#A4A5A8"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.2004,
  cy: 7.2,
  r: 1.2,
  transform: "rotate(90 20.2004 7.2)",
  fill: "#A4A5A8"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.11602,
  cy: 18.8174,
  r: 1.2,
  fill: "#A4A5A8"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.8713,
  cy: 18.8174,
  r: 1.2,
  transform: "rotate(90 18.8713 18.8174)",
  fill: "#A4A5A8"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 6.5,
  stroke: "#A4A5A8"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9.5,
  stroke: "#A4A5A8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M10 9.87549H11.0344L13.09 12.7757V9.87549H14V14.1243H12.9656L10.91 11.1783V14.1243H10V9.87549Z",
  fill: "#A4A5A8"
});

function SvgNitron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitron);
export default __webpack_public_path__ + "static/media/Nitron.a17ccca0f5f2ac0d679e14ec189caf3d.svg";
export { ForwardRef as ReactComponent };